/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Dashboard,
  DeviceStatus,
  HTTPValidationError,
  LegacyMigrationInfo,
  NewSeason,
  QualityCheck,
  SearchHit,
  Season,
  SeasonDeleted,
  SettingValue,
  TableExport,
  TablePrint,
  UserSettings,
  WorkspaceDashboardParams,
  WorkspaceQualityParams,
  WorkspaceSearchParams
} from '../model';

import { apiFetch } from '../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getWorkspaceDashboardUrl = (params: WorkspaceDashboardParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/dashboard?${stringifiedParams}` : `/api/v1/dashboard`
}

/**
 * @summary Home page: season cycle, items needing attention, jobs, totals
 */
export const workspaceDashboard = async (params: WorkspaceDashboardParams, options?: Parameters<typeof apiFetch>[1]): Promise<Dashboard> => {

  return apiFetch<Dashboard>(getWorkspaceDashboardUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkspaceDashboardQueryKey = (params?: WorkspaceDashboardParams,) => {
    return [
    `/api/v1/dashboard`, ...(params ? [params] : [])
    ] as const;
    }


export const getWorkspaceDashboardQueryOptions = <TData = Awaited<ReturnType<typeof workspaceDashboard>>, TError = HTTPValidationError>(params: WorkspaceDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceDashboard>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspaceDashboardQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspaceDashboard>>> = ({ signal }) => workspaceDashboard(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspaceDashboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspaceDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof workspaceDashboard>>>
export type WorkspaceDashboardQueryError = HTTPValidationError


export function useWorkspaceDashboard<TData = Awaited<ReturnType<typeof workspaceDashboard>>, TError = HTTPValidationError>(
 params: WorkspaceDashboardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceDashboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDashboard>>,
          TError,
          Awaited<ReturnType<typeof workspaceDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceDashboard<TData = Awaited<ReturnType<typeof workspaceDashboard>>, TError = HTTPValidationError>(
 params: WorkspaceDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceDashboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDashboard>>,
          TError,
          Awaited<ReturnType<typeof workspaceDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceDashboard<TData = Awaited<ReturnType<typeof workspaceDashboard>>, TError = HTTPValidationError>(
 params: WorkspaceDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceDashboard>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Home page: season cycle, items needing attention, jobs, totals
 */

export function useWorkspaceDashboard<TData = Awaited<ReturnType<typeof workspaceDashboard>>, TError = HTTPValidationError>(
 params: WorkspaceDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceDashboard>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspaceDashboardQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWorkspaceDevicesUrl = () => {




  return `/api/v1/devices`
}

/**
 * @summary Instrument clients and when they last sent data
 */
export const workspaceDevices = async ( options?: Parameters<typeof apiFetch>[1]): Promise<DeviceStatus[]> => {

  return apiFetch<DeviceStatus[]>(getWorkspaceDevicesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkspaceDevicesQueryKey = () => {
    return [
    `/api/v1/devices`
    ] as const;
    }


export const getWorkspaceDevicesQueryOptions = <TData = Awaited<ReturnType<typeof workspaceDevices>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceDevices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspaceDevicesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspaceDevices>>> = ({ signal }) => workspaceDevices({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspaceDevices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspaceDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof workspaceDevices>>>
export type WorkspaceDevicesQueryError = unknown


export function useWorkspaceDevices<TData = Awaited<ReturnType<typeof workspaceDevices>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceDevices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDevices>>,
          TError,
          Awaited<ReturnType<typeof workspaceDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceDevices<TData = Awaited<ReturnType<typeof workspaceDevices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceDevices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceDevices>>,
          TError,
          Awaited<ReturnType<typeof workspaceDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceDevices<TData = Awaited<ReturnType<typeof workspaceDevices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceDevices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Instrument clients and when they last sent data
 */

export function useWorkspaceDevices<TData = Awaited<ReturnType<typeof workspaceDevices>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceDevices>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspaceDevicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWorkspaceLegacyUrl = () => {




  return `/api/v1/legacy-migration`
}

/**
 * @summary State of the one-off legacy data migration
 */
export const workspaceLegacy = async ( options?: Parameters<typeof apiFetch>[1]): Promise<LegacyMigrationInfo> => {

  return apiFetch<LegacyMigrationInfo>(getWorkspaceLegacyUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkspaceLegacyQueryKey = () => {
    return [
    `/api/v1/legacy-migration`
    ] as const;
    }


export const getWorkspaceLegacyQueryOptions = <TData = Awaited<ReturnType<typeof workspaceLegacy>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceLegacy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspaceLegacyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspaceLegacy>>> = ({ signal }) => workspaceLegacy({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspaceLegacy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspaceLegacyQueryResult = NonNullable<Awaited<ReturnType<typeof workspaceLegacy>>>
export type WorkspaceLegacyQueryError = unknown


export function useWorkspaceLegacy<TData = Awaited<ReturnType<typeof workspaceLegacy>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceLegacy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceLegacy>>,
          TError,
          Awaited<ReturnType<typeof workspaceLegacy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceLegacy<TData = Awaited<ReturnType<typeof workspaceLegacy>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceLegacy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceLegacy>>,
          TError,
          Awaited<ReturnType<typeof workspaceLegacy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceLegacy<TData = Awaited<ReturnType<typeof workspaceLegacy>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceLegacy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary State of the one-off legacy data migration
 */

export function useWorkspaceLegacy<TData = Awaited<ReturnType<typeof workspaceLegacy>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceLegacy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspaceLegacyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWorkspaceQualityUrl = (params?: WorkspaceQualityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/quality?${stringifiedParams}` : `/api/v1/quality`
}

/**
 * @summary Data-quality checks (counts)
 */
export const workspaceQuality = async (params?: WorkspaceQualityParams, options?: Parameters<typeof apiFetch>[1]): Promise<QualityCheck[]> => {

  return apiFetch<QualityCheck[]>(getWorkspaceQualityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkspaceQualityQueryKey = (params?: WorkspaceQualityParams,) => {
    return [
    `/api/v1/quality`, ...(params ? [params] : [])
    ] as const;
    }


export const getWorkspaceQualityQueryOptions = <TData = Awaited<ReturnType<typeof workspaceQuality>>, TError = HTTPValidationError>(params?: WorkspaceQualityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceQuality>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspaceQualityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspaceQuality>>> = ({ signal }) => workspaceQuality(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspaceQuality>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspaceQualityQueryResult = NonNullable<Awaited<ReturnType<typeof workspaceQuality>>>
export type WorkspaceQualityQueryError = HTTPValidationError


export function useWorkspaceQuality<TData = Awaited<ReturnType<typeof workspaceQuality>>, TError = HTTPValidationError>(
 params: undefined |  WorkspaceQualityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceQuality>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceQuality>>,
          TError,
          Awaited<ReturnType<typeof workspaceQuality>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceQuality<TData = Awaited<ReturnType<typeof workspaceQuality>>, TError = HTTPValidationError>(
 params?: WorkspaceQualityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceQuality>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceQuality>>,
          TError,
          Awaited<ReturnType<typeof workspaceQuality>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceQuality<TData = Awaited<ReturnType<typeof workspaceQuality>>, TError = HTTPValidationError>(
 params?: WorkspaceQualityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceQuality>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Data-quality checks (counts)
 */

export function useWorkspaceQuality<TData = Awaited<ReturnType<typeof workspaceQuality>>, TError = HTTPValidationError>(
 params?: WorkspaceQualityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceQuality>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspaceQualityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWorkspaceSearchUrl = (params: WorkspaceSearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/search?${stringifiedParams}` : `/api/v1/search`
}

/**
 * @summary Quick search (Ctrl K): genotypes, trials, plot codes, partners, saved queries
 */
export const workspaceSearch = async (params: WorkspaceSearchParams, options?: Parameters<typeof apiFetch>[1]): Promise<SearchHit[]> => {

  return apiFetch<SearchHit[]>(getWorkspaceSearchUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkspaceSearchQueryKey = (params?: WorkspaceSearchParams,) => {
    return [
    `/api/v1/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getWorkspaceSearchQueryOptions = <TData = Awaited<ReturnType<typeof workspaceSearch>>, TError = HTTPValidationError>(params: WorkspaceSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSearch>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspaceSearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspaceSearch>>> = ({ signal }) => workspaceSearch(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspaceSearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspaceSearchQueryResult = NonNullable<Awaited<ReturnType<typeof workspaceSearch>>>
export type WorkspaceSearchQueryError = HTTPValidationError


export function useWorkspaceSearch<TData = Awaited<ReturnType<typeof workspaceSearch>>, TError = HTTPValidationError>(
 params: WorkspaceSearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceSearch>>,
          TError,
          Awaited<ReturnType<typeof workspaceSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceSearch<TData = Awaited<ReturnType<typeof workspaceSearch>>, TError = HTTPValidationError>(
 params: WorkspaceSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceSearch>>,
          TError,
          Awaited<ReturnType<typeof workspaceSearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceSearch<TData = Awaited<ReturnType<typeof workspaceSearch>>, TError = HTTPValidationError>(
 params: WorkspaceSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSearch>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Quick search (Ctrl K): genotypes, trials, plot codes, partners, saved queries
 */

export function useWorkspaceSearch<TData = Awaited<ReturnType<typeof workspaceSearch>>, TError = HTTPValidationError>(
 params: WorkspaceSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSearch>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspaceSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWorkspaceSeasonsUrl = () => {




  return `/api/v1/seasons`
}

/**
 * @summary Breeding seasons (years) with plot and trial counts
 */
export const workspaceSeasons = async ( options?: Parameters<typeof apiFetch>[1]): Promise<Season[]> => {

  return apiFetch<Season[]>(getWorkspaceSeasonsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkspaceSeasonsQueryKey = () => {
    return [
    `/api/v1/seasons`
    ] as const;
    }


export const getWorkspaceSeasonsQueryOptions = <TData = Awaited<ReturnType<typeof workspaceSeasons>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSeasons>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspaceSeasonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspaceSeasons>>> = ({ signal }) => workspaceSeasons({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspaceSeasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspaceSeasonsQueryResult = NonNullable<Awaited<ReturnType<typeof workspaceSeasons>>>
export type WorkspaceSeasonsQueryError = unknown


export function useWorkspaceSeasons<TData = Awaited<ReturnType<typeof workspaceSeasons>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSeasons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceSeasons>>,
          TError,
          Awaited<ReturnType<typeof workspaceSeasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceSeasons<TData = Awaited<ReturnType<typeof workspaceSeasons>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSeasons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceSeasons>>,
          TError,
          Awaited<ReturnType<typeof workspaceSeasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceSeasons<TData = Awaited<ReturnType<typeof workspaceSeasons>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSeasons>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Breeding seasons (years) with plot and trial counts
 */

export function useWorkspaceSeasons<TData = Awaited<ReturnType<typeof workspaceSeasons>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSeasons>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspaceSeasonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWorkspaceCreateSeasonUrl = () => {




  return `/api/v1/seasons`
}

/**
 * @summary Open a new breeding season (year)
 */
export const workspaceCreateSeason = async (newSeason: NewSeason, options?: Parameters<typeof apiFetch>[1]): Promise<Season[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<Season[]>(getWorkspaceCreateSeasonUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(newSeason)
  }
);}





export const getWorkspaceCreateSeasonMutationKey = () => ['workspaceCreateSeason'] as const;

export const getWorkspaceCreateSeasonMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspaceCreateSeason>>, TError,WorkspaceCreateSeasonMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workspaceCreateSeason>>, TError,WorkspaceCreateSeasonMutationVariables, TContext> => {

const mutationKey = getWorkspaceCreateSeasonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspaceCreateSeason>>, WorkspaceCreateSeasonMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  workspaceCreateSeason(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkspaceCreateSeasonMutationResult = NonNullable<Awaited<ReturnType<typeof workspaceCreateSeason>>>
    export type WorkspaceCreateSeasonMutationBody = NewSeason
    export type WorkspaceCreateSeasonMutationError = HTTPValidationError
    export type WorkspaceCreateSeasonMutationVariables = {data: NewSeason}

    /**
 * @summary Open a new breeding season (year)
 */
export const useWorkspaceCreateSeason = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspaceCreateSeason>>, TError,WorkspaceCreateSeasonMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workspaceCreateSeason>>,
        TError,
        WorkspaceCreateSeasonMutationVariables,
        TContext
      > => {
      return useMutation(getWorkspaceCreateSeasonMutationOptions(options), queryClient);
    }
    export const getWorkspaceDeleteSeasonUrl = (ev: number,) => {




  return `/api/v1/seasons/${ev}`
}

/**
 * @summary Remove an empty breeding season opened by mistake (administrators; refused while any row names the year)
 */
export const workspaceDeleteSeason = async (ev: number, options?: Parameters<typeof apiFetch>[1]): Promise<SeasonDeleted> => {

  return apiFetch<SeasonDeleted>(getWorkspaceDeleteSeasonUrl(ev),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getWorkspaceDeleteSeasonMutationKey = () => ['workspaceDeleteSeason'] as const;

export const getWorkspaceDeleteSeasonMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspaceDeleteSeason>>, TError,WorkspaceDeleteSeasonMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workspaceDeleteSeason>>, TError,WorkspaceDeleteSeasonMutationVariables, TContext> => {

const mutationKey = getWorkspaceDeleteSeasonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspaceDeleteSeason>>, WorkspaceDeleteSeasonMutationVariables> = (props) => {
          const {ev} = props ?? {};

          return  workspaceDeleteSeason(ev,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkspaceDeleteSeasonMutationResult = NonNullable<Awaited<ReturnType<typeof workspaceDeleteSeason>>>

    export type WorkspaceDeleteSeasonMutationError = HTTPValidationError
    export type WorkspaceDeleteSeasonMutationVariables = {ev: number}

    /**
 * @summary Remove an empty breeding season opened by mistake (administrators; refused while any row names the year)
 */
export const useWorkspaceDeleteSeason = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspaceDeleteSeason>>, TError,WorkspaceDeleteSeasonMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workspaceDeleteSeason>>,
        TError,
        WorkspaceDeleteSeasonMutationVariables,
        TContext
      > => {
      return useMutation(getWorkspaceDeleteSeasonMutationOptions(options), queryClient);
    }
    export const getWorkspaceSettingsUrl = () => {




  return `/api/v1/settings`
}

/**
 * @summary The user's settings (personal values over the global defaults)
 */
export const workspaceSettings = async ( options?: Parameters<typeof apiFetch>[1]): Promise<UserSettings> => {

  return apiFetch<UserSettings>(getWorkspaceSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getWorkspaceSettingsQueryKey = () => {
    return [
    `/api/v1/settings`
    ] as const;
    }


export const getWorkspaceSettingsQueryOptions = <TData = Awaited<ReturnType<typeof workspaceSettings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkspaceSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof workspaceSettings>>> = ({ signal }) => workspaceSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workspaceSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WorkspaceSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof workspaceSettings>>>
export type WorkspaceSettingsQueryError = unknown


export function useWorkspaceSettings<TData = Awaited<ReturnType<typeof workspaceSettings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceSettings>>,
          TError,
          Awaited<ReturnType<typeof workspaceSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceSettings<TData = Awaited<ReturnType<typeof workspaceSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workspaceSettings>>,
          TError,
          Awaited<ReturnType<typeof workspaceSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWorkspaceSettings<TData = Awaited<ReturnType<typeof workspaceSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The user's settings (personal values over the global defaults)
 */

export function useWorkspaceSettings<TData = Awaited<ReturnType<typeof workspaceSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workspaceSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWorkspaceSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWorkspaceSaveGlobalSettingUrl = (key: string,) => {




  return `/api/v1/settings/global/${key}`
}

/**
 * @summary Store a default for everyone (administrators); returns the defaults
 */
export const workspaceSaveGlobalSetting = async (key: string,
    settingValue: SettingValue, options?: Parameters<typeof apiFetch>[1]): Promise<UserSettings> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<UserSettings>(getWorkspaceSaveGlobalSettingUrl(key),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(settingValue)
  }
);}





export const getWorkspaceSaveGlobalSettingMutationKey = () => ['workspaceSaveGlobalSetting'] as const;

export const getWorkspaceSaveGlobalSettingMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspaceSaveGlobalSetting>>, TError,WorkspaceSaveGlobalSettingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workspaceSaveGlobalSetting>>, TError,WorkspaceSaveGlobalSettingMutationVariables, TContext> => {

const mutationKey = getWorkspaceSaveGlobalSettingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspaceSaveGlobalSetting>>, WorkspaceSaveGlobalSettingMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  workspaceSaveGlobalSetting(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkspaceSaveGlobalSettingMutationResult = NonNullable<Awaited<ReturnType<typeof workspaceSaveGlobalSetting>>>
    export type WorkspaceSaveGlobalSettingMutationBody = SettingValue
    export type WorkspaceSaveGlobalSettingMutationError = HTTPValidationError
    export type WorkspaceSaveGlobalSettingMutationVariables = {key: string;data: SettingValue}

    /**
 * @summary Store a default for everyone (administrators); returns the defaults
 */
export const useWorkspaceSaveGlobalSetting = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspaceSaveGlobalSetting>>, TError,WorkspaceSaveGlobalSettingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workspaceSaveGlobalSetting>>,
        TError,
        WorkspaceSaveGlobalSettingMutationVariables,
        TContext
      > => {
      return useMutation(getWorkspaceSaveGlobalSettingMutationOptions(options), queryClient);
    }
    export const getWorkspaceSaveSettingUrl = (key: string,) => {




  return `/api/v1/settings/${key}`
}

/**
 * @summary Store one personal setting
 */
export const workspaceSaveSetting = async (key: string,
    settingValue: SettingValue, options?: Parameters<typeof apiFetch>[1]): Promise<UserSettings> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<UserSettings>(getWorkspaceSaveSettingUrl(key),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(settingValue)
  }
);}





export const getWorkspaceSaveSettingMutationKey = () => ['workspaceSaveSetting'] as const;

export const getWorkspaceSaveSettingMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspaceSaveSetting>>, TError,WorkspaceSaveSettingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workspaceSaveSetting>>, TError,WorkspaceSaveSettingMutationVariables, TContext> => {

const mutationKey = getWorkspaceSaveSettingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspaceSaveSetting>>, WorkspaceSaveSettingMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  workspaceSaveSetting(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkspaceSaveSettingMutationResult = NonNullable<Awaited<ReturnType<typeof workspaceSaveSetting>>>
    export type WorkspaceSaveSettingMutationBody = SettingValue
    export type WorkspaceSaveSettingMutationError = HTTPValidationError
    export type WorkspaceSaveSettingMutationVariables = {key: string;data: SettingValue}

    /**
 * @summary Store one personal setting
 */
export const useWorkspaceSaveSetting = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspaceSaveSetting>>, TError,WorkspaceSaveSettingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workspaceSaveSetting>>,
        TError,
        WorkspaceSaveSettingMutationVariables,
        TContext
      > => {
      return useMutation(getWorkspaceSaveSettingMutationOptions(options), queryClient);
    }
    export const getWorkspaceTableExportUrl = () => {




  return `/api/v1/table-export.xlsx`
}

/**
 * @summary A table the way a page shows it (its rows, column order and column names) as an .xlsx file
 */
export const workspaceTableExport = async (tableExport: TableExport, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<void>(getWorkspaceTableExportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tableExport)
  }
);}





export const getWorkspaceTableExportMutationKey = () => ['workspaceTableExport'] as const;

export const getWorkspaceTableExportMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspaceTableExport>>, TError,WorkspaceTableExportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workspaceTableExport>>, TError,WorkspaceTableExportMutationVariables, TContext> => {

const mutationKey = getWorkspaceTableExportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspaceTableExport>>, WorkspaceTableExportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  workspaceTableExport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkspaceTableExportMutationResult = NonNullable<Awaited<ReturnType<typeof workspaceTableExport>>>
    export type WorkspaceTableExportMutationBody = TableExport
    export type WorkspaceTableExportMutationError = HTTPValidationError
    export type WorkspaceTableExportMutationVariables = {data: TableExport}

    /**
 * @summary A table the way a page shows it (its rows, column order and column names) as an .xlsx file
 */
export const useWorkspaceTableExport = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspaceTableExport>>, TError,WorkspaceTableExportMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workspaceTableExport>>,
        TError,
        WorkspaceTableExportMutationVariables,
        TContext
      > => {
      return useMutation(getWorkspaceTableExportMutationOptions(options), queryClient);
    }
    export const getWorkspaceTablePrintUrl = () => {




  return `/api/v1/table-print.pdf`
}

/**
 * @summary A table the way a page shows it as A4 pages to print: when and where it was printed, its settings, page numbers
 */
export const workspaceTablePrint = async (tablePrint: TablePrint, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<void>(getWorkspaceTablePrintUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(tablePrint)
  }
);}





export const getWorkspaceTablePrintMutationKey = () => ['workspaceTablePrint'] as const;

export const getWorkspaceTablePrintMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspaceTablePrint>>, TError,WorkspaceTablePrintMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof workspaceTablePrint>>, TError,WorkspaceTablePrintMutationVariables, TContext> => {

const mutationKey = getWorkspaceTablePrintMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workspaceTablePrint>>, WorkspaceTablePrintMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  workspaceTablePrint(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WorkspaceTablePrintMutationResult = NonNullable<Awaited<ReturnType<typeof workspaceTablePrint>>>
    export type WorkspaceTablePrintMutationBody = TablePrint
    export type WorkspaceTablePrintMutationError = HTTPValidationError
    export type WorkspaceTablePrintMutationVariables = {data: TablePrint}

    /**
 * @summary A table the way a page shows it as A4 pages to print: when and where it was printed, its settings, page numbers
 */
export const useWorkspaceTablePrint = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workspaceTablePrint>>, TError,WorkspaceTablePrintMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof workspaceTablePrint>>,
        TError,
        WorkspaceTablePrintMutationVariables,
        TContext
      > => {
      return useMutation(getWorkspaceTablePrintMutationOptions(options), queryClient);
    }
